// FileUpload.js

import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Button } from "reactstrap";


const FileUpload = ({ control, name, label, allowedFileTypes, onFileChange, onDelete, uploadedFile, setIsoFile, setUploadedFile, uploadClass, deleteClass, uploaMainWrap, rules, errors }) => {
  const [inputKey, setInputKey] = useState(Date.now());

  const handleDelete = () => {
    if (setUploadedFile) {
      setUploadedFile(null);
    }
    if (onDelete) {
      onDelete();
    }
  };

  const isAcceptedFormat = (file) => {
    return file && allowedFileTypes?.includes(file?.type);
  };

  const handleFileChange = (file) => {
    onFileChange(file);
    setInputKey(Date.now());

    // If a file is already uploaded, delete it before uploading the new one
    if (uploadedFile) {
      handleDelete();
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      rules={rules}
      render={({ field }) => (
        <div className={`hl-upload-delete-wrap ${uploaMainWrap || ''}`}>
          <input
            key={inputKey}
            type="file"
            onChange={(e) => {
              field.onChange(e.target.files[0]);
              handleFileChange(e.target.files[0]);
            }}
            style={{ display: "none" }}
            // ref={(inputRef) => (field.ref = inputRef)}
            ref={field.ref}
          />
          <div className="hl-upload-btn-small">
            <Button
              className={`hl-upload-btn right ${uploadClass || ''}`}
              variant="upload"
              title="Upload"
              onClick={(el) => {
                let elSelector = el.target.closest(".hl-upload-delete-wrap").querySelector('input[type="file"]');
                // if (field.ref) {
                //   field.ref.click();
                // }
                if (elSelector) {
                  elSelector.click();
                }
              }}
            >
              <div className="upload mr-0"></div>
            </Button>
          </div>
          <div className="hl-download-btn hl-file-upload-title">
            {/* <div className="hl-file-title">
              <span title={isAcceptedFormat(field.value) ? field.value?.name : ""}>
                {isAcceptedFormat(field.value) ? field.value?.name : ""}
              </span>
            </div> */}
            {uploadedFile?.fileName && !uploadedFile.isRemove && (
              <div className={`hl-download-btn ${deleteClass || ''}`}>
                <div className="hl-file-title">
                  <span title={isAcceptedFormat(field.value) ? field.value?.name : uploadedFile?.fileName}>
                    {isAcceptedFormat(field.value) ? field.value?.name : uploadedFile?.fileName}
                  </span>
                  <span type="button" title="Delete" className="hl-file-delete" onClick={handleDelete}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            )}
          </div>
          {errors && errors?.type === "required" && <span className="text-help">{errors?.message}</span>}
        </div>
      )}
    />
  );
};

export default FileUpload;
